import React from 'react'

export default function AddCarouselDetails() {
  return (
    <div>AddCarouselDetails</div>
  )
}
